import { getRouterSelectors, RouterReducerState } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from './app.reducer';
import { NdtRouteData } from './pages/site-layout/models/route-definitions';

export const selectRouter = createFeatureSelector<AppState, RouterReducerState<any>>('router');

export const {
   selectCurrentRoute,
   selectQueryParams, // select the current route query params
   selectRouteParams, // select the current route params
   selectRouteData, // select the current route data
   selectUrl, // select the current url
   selectQueryParam,
   selectRouteParam,
} = getRouterSelectors(selectRouter);

/** @deprecated use selectQueryParams */
export const getQueryParams = selectQueryParams;
/** @deprecated use selectRouteParams */
export const getRouteParams = selectRouteParams;
/** @deprecated use selectRouteData */
export const getRouteData = selectRouteData;
/** @deprecated use selectUrl */
export const getUrl = selectUrl;

const selectId = selectRouteParam('id');

export const selectIdRouteParam = (state: AppState) => {
   const id = selectId(state);
   if (id) {
      const num = parseInt(id.trim(), 10);
      if (!isNaN(num)) {
         return num;
      }
   }
   return null;
};

export const getShowTopBar = createSelector(selectRouteData, (data: NdtRouteData) => {
   return data != null && data.showTopBar !== false;
});

export const selectSearchTerms = (state: AppState) => {
   const searchTerms = selectQueryParam('searchTerms')(state);
   return searchTerms ? searchTerms : '';
};
